import type { GetVacancyCandidatesRequest } from '@entities/vacancy';

export const POSITIVE_CANDIDATES_PARAMS = {
  page: 1,
  perPage: 2,
  filter: { decisionType: 'POSITIVE' },
} satisfies GetVacancyCandidatesRequest;

export const PENDING_CANDIDATES_PARAMS = {
  page: 1,
  perPage: 1,
  filter: { decisionType: 'PENDING' },
} satisfies GetVacancyCandidatesRequest;

export const ALL_PENDING_CANDIDATES_PARAMS = {
  filter: { decisionType: 'PENDING' },
} satisfies Omit<GetVacancyCandidatesRequest, 'paginate'>;
